export default __webpack_public_path__ + "static/media/promo.70347578.svg";